import { Suspense } from 'react';
import { Outlet } from '@tanstack/react-router';

import { Layout } from '../layout/Layout';
import { LoadingIndicator } from '../shell/LoadingIndicator';
import { rootRoute } from './rootRoute';

export function RootComponent() {
  const { config } = rootRoute.useRouteContext();

  return (
    <Layout config={config}>
      <Suspense fallback={<LoadingIndicator />}>
        <Outlet />
      </Suspense>
    </Layout>
  );
}
